import * as React from "react"
import PropTypes from "prop-types"

const SectionTitle = ({ title, bgText, className }) => {
  return (
    <div
      className={`relative ${className}`}
    >
      <div className="text-blue-50 font-bold text-4xl lg:text-6xl">{bgText}</div>
      <h2 className="absolute top-0 left-0 font-bold text-2xl lg:text-4xl text-brandNavy tracking-wide">
        {title}
      </h2>
    </div>
  )
}

SectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  bgText: PropTypes.string,
}

export default SectionTitle
